var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecorativeImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.835 156.832C53.835 163.816 56.6094 170.514 61.5478 175.453C66.4863 180.391 73.1843 183.166 80.1683 183.166C87.1523 183.166 93.8503 180.391 98.7888 175.453C103.727 170.514 106.502 163.816 106.502 156.832C106.502 149.848 103.727 143.15 98.7888 138.212C93.8503 133.273 87.1523 130.499 80.1683 130.499C73.1843 130.499 66.4863 133.273 61.5478 138.212C56.6094 143.15 53.835 149.848 53.835 156.832Z",
    stroke: "#E8F7FB",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3333 77.8333L49.6667 9H9M99.3333 77.8333H109.5C116.484 77.8333 123.182 80.6077 128.12 85.5462C133.059 90.4847 135.833 97.1826 135.833 104.167V156.833H115.5M99.3333 77.8333H9M50.8333 156.833H9M23.3333 77.8333V9M117.833 39V18M165 91H183M165 139.5L183.667 153.833M156 49.5L171.667 34.1667",
    stroke: "#E8F7FB",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorativeImage);
export default __webpack_public_path__ + "static/media/DecorativeImage.593db51d3d8e6dd1d3a9f64decacaee8.svg";
export { ForwardRef as ReactComponent };